import { useRecoilState } from "recoil";
import { loadingState } from "src/atoms/loadingAtom";
import { CONSTANTS } from "src/constants";

const useLoading = () => {
  const [isLoading, setIsLoading] = useRecoilState(loadingState);

  const startLoading = () =>
    setIsLoading(CONSTANTS.COMMON_CONSTANTS.START_LOADER);
  const stopLoading = () =>
    setIsLoading(CONSTANTS.COMMON_CONSTANTS.STOP_LOADER);

  return { isLoading, startLoading, stopLoading };
};

export default useLoading;
